var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('hr',{staticClass:"divider",class:_vm.customClasses,style:(_vm.cssVars)})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/PageDivider.vue